import React from "react";
import { useTranslation } from "react-i18next";
import ScaledImage from "../../components/ScaledImage";
import { ReportsDataCompany } from "./models";

interface Props {
  data: ReportsDataCompany;
}

const ReportsCompany = ({ data }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="report report--company">
      <h3 className="report__title">{t(data.title)}</h3>
      {data.value.map((item, i) => (
        <div key={i} className="preview-item preview-item--company">
          <div className="preview-item__image">
            <ScaledImage url={item.logoUrl || "/assets/logo_placeholder.png"} width={124} height={58} />
          </div>
          <div className="preview-item__content">
            <h2 className="preview-item__title">{item.title}</h2>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReportsCompany;
